import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Tooltip } from "antd";
import { FaCheckCircle, FaArchive, FaCog, FaEye } from "react-icons/fa";
import i18n from "i18next";
import _ from "underscore";

import { mapStatus } from "../../constants/status";
import { actionSaveMap } from "../../constants/actions";
import { setZoneActive, setSpinning } from "../../redux/designerPropertiesSlice";
import { CanvasConfigModal } from "./calibration/CanvasConfigModal";

export const Header = ({
  map,
  canvasRef,
  screenCaptureAction,
  action,
  saveMap,
  onChangeCanvas,
  openModal,
  onChangePreview
}) => {
  const { available, zoneActive } = useSelector((state) => state.properties);
  const [canvasConfigVisible, setCanvasConfigVisible] = useState(false);

  const openCanvasConfig = () => setCanvasConfigVisible(true);
  const closeCanvasConfig = () => setCanvasConfigVisible(false);


  const dispatch = useDispatch();
  const isCropping = canvasRef
    ? canvasRef.handler?.interactionMode === "crop"
    : false;

  const onUndoRedoHandler = (type) => {
    _.partial(saveMap, actionSaveMap.updateLayout);
    type == "redo"
      ? canvasRef.handler?.transactionHandler.redo()
      : canvasRef.handler?.transactionHandler.undo();
  };

  const StatusTag = ({ status }) => {
    const statusMap = {
      [mapStatus.modified]: "modified",
      [mapStatus.saved]: "saved",
      [mapStatus.published]: "published",
    };

    const currentStatus = statusMap[status];
    if (!currentStatus) return null;

    return (
      <span className={`tag-save ${status !== mapStatus.modified ? " green" : ""}`}>
        <FaCheckCircle /> {i18n.t(`mapeditor.actions.${currentStatus}`)}
      </span>
    );
  };

  const ActionButton = ({ type, loading, onClick }) => {
    const config = {
      saving: {
        text: "Guardando",
        btnKey: "save",
        actionRequired: actionSaveMap.updateLayout,
        disabled: false,
      },
      publishing: {
        text: "Publicando",
        btnKey: "publish",
        actionRequired: actionSaveMap.publish,
        disabled: !available,
      },
    }[type];

    if (action === type) {
      return (
        <div className="box__saving">
          <div className="loader"></div> <span>{config.text}</span>
        </div>
      );
    }

    return (
      <button
        className="btn_neutro"
        onClick={_.partial(saveMap, config.actionRequired)}
        disabled={config.disabled}
      >
        <FaCheckCircle /> {i18n.t(`mapeditor.btns.${config.btnKey}`)}
      </button>
    );
  };

  const saveContent = (
    <div className="wrapper__saving">
      <StatusTag status={map.status} />

      {map.status === mapStatus.modified && (
        <ActionButton type="saving" />
      )}

      {map.isPublished && map.status === mapStatus.saved && (
        <ActionButton type="publishing" />
      )}
    </div>
  );

  const onExit = () => {
    const exit = () => window.redseats.onExitDesigner();

    if (map.status !== mapStatus.modified) {
      return exit();
    }

    Modal.confirm({
      title: "¿Salir sin guardar?",
      content: "Perderás los cambios no guardados.",
      okText: "Salir",
      cancelText: "Cancelar",
      okType: "danger",
      onOk: exit,
    });
  };

  const onSectionExit = () => {
    canvasRef.handler.zoomHandler.zoomOneToOne();
    canvasRef.handler.onZone(true);
    dispatch(setZoneActive(false));
  }

  const loadContent = (
    <>
      {(!map || (map && !map.isPublished)) && (
        <button
          className="btn_neutro"
          onClick={openModal}
        >
          <FaArchive /> {i18n.t("mapeditor.map.load-map")}
        </button>
      )}
    </>
  );

  const exitRedSeats = (
    <>
      <div className="nav-header-title-btn">
        <button className="btn-light circle" onClick={onExit}>
          <span className="icon-close-circular">
            <span className="path1"></span>
          </span>
        </button>
      </div>
      <div className="nav-header-title-titles">
        <h6 className="title">{map.name}</h6>
        <div className="subtitle">
          <span>{i18n.t("mapeditor.venue")}</span>
        </div>
      </div>
      <div className="saving-action">{saveContent}</div>
      <div>{loadContent}</div>
    </>
  );

  const exitSection = (
    <>
      <div className="nav-header-title-btn">
        <button className="btn-light circle" onClick={onSectionExit}>
          <span className="icon-close-circular">
            <span className="path1"></span>
          </span>
        </button>
      </div>
      <div className="nav-header-title-titles">
        <h6 className="title">Salir de la seccion</h6>
      </div>
    </>
  );



  return (
    <>
      <nav>
        <div className="nav-header">
          <div className="content_nav_one">
            <div className="nav-header-title">
              {zoneActive ? exitSection : exitRedSeats}
            </div>
          </div>
          <div className="content_nav_two">
            <div className="nav-header-btns">
              <Tooltip
                title={"Vista previa"}
                placement="bottom"
              >
                <Button
                  className="btn__tool"
                  onClick={() => {
                    onChangePreview(true)
                  }}
                >
                  <FaEye />
                </Button>
              </Tooltip>
              {screenCaptureAction}
              <Tooltip
                title={"Cofiguración de canvas"}
                placement="bottom"
              >
                <Button
                  className="btn__tool"
                  onClick={openCanvasConfig}
                >
                  <FaCog />
                </Button>
              </Tooltip>
              <Tooltip
                title={i18n.t("mapeditor.actions.undo")}
                placement="bottom"
              >
                <Button
                  disabled={
                    isCropping ||
                    (canvasRef &&
                      canvasRef.handler?.transactionHandler.undos.length <= 1)
                  }
                  onClick={() => onUndoRedoHandler("undo")}
                  className="btn__tool"
                >
                  <span className="icon-undo"></span>
                </Button>
              </Tooltip>
              <Tooltip
                title={i18n.t("mapeditor.actions.redo")}
                placement="bottom"
              >
                <Button
                  disabled={
                    isCropping ||
                    (canvasRef &&
                      !canvasRef.handler?.transactionHandler.redos.length)
                  }
                  onClick={() => onUndoRedoHandler("redo")}
                  className="btn__tool"
                >
                  <span className="icon-redo"></span>
                </Button>
              </Tooltip>
            </div>
          </div>
        </div>
      </nav>
      <CanvasConfigModal
        visible={canvasConfigVisible}
        onClose={closeCanvasConfig}
        canvasRef={canvasRef}
        saveMap={saveMap}
        onChangeCanvas={onChangeCanvas}
      />
    </>
  );
};
